import NewsletterSignup from "@/components/NewsletterSignup";
import { Section } from "@/components/common";
import { Newspaper, Users, Briefcase } from "lucide-react";

export default function NewsletterPage() {
  return (
    <Section className="py-12 sm:py-16 max-w-5xl">
      <div className="text-center mb-10">
        <p className="eyebrow mb-2">Free · Weekly · Monday 8am ET</p>
        <h1 className="font-display font-black text-4xl sm:text-5xl text-white">The DYORUSA weekly newsletter</h1>
        <p className="text-slate-400 mt-4 max-w-2xl mx-auto">A lead story, the most relevant briefs, a Claims-vs-Evidence item, water/power updates, and highlights for your state — all with source links.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mb-10">
        <div className="card p-6" data-testid="edition-citizen">
          <Users className="text-[#84CC16] mb-3" />
          <h3 className="font-display font-bold text-xl text-white">Citizen edition</h3>
          <p className="text-slate-400 text-sm mt-2">Local and state news, plain-language explanations, water & power updates, community impacts, public-meeting and permitting info when available, and useful questions residents can ask.</p>
        </div>
        <div className="card p-6" data-testid="edition-professional">
          <Briefcase className="text-[#3B82F6] mb-3" />
          <h3 className="font-display font-bold text-xl text-white">Professional edition</h3>
          <p className="text-slate-400 text-sm mt-2">For customers, operators, developers, utilities, and infrastructure teams: power & grid developments, projects, policy, cooling, water, and market news.</p>
        </div>
      </div>

      <div className="max-w-xl mx-auto"><NewsletterSignup /></div>

      <div className="flex items-center justify-center gap-2 mt-6 text-slate-500 text-sm">
        <Newspaper size={14} /> We never sell or rent your list. Update preferences or unsubscribe anytime.
      </div>
    </Section>
  );
}
